export const OTF_STATUS = {
  DRAFT: "Draft",
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  COMPLETED: "Ready To Bill",
  BBA_Confirmed: "Confirmed",
  BILLED: "Billed",
  COLLECTED: "Collected",
};

export const getMaxAllowedStep = (status, user) => {
  const userRole = user?.roles;
  if (userRole?.includes("USER")) {
    if (status === OTF_STATUS.DRAFT) return 4;
    if (status === OTF_STATUS.SUBMITTED) return 4;
    return 4;
  }

  if (userRole?.includes("CRM")) {
    if (status === OTF_STATUS.DRAFT) return 4;
    if (status === OTF_STATUS.SUBMITTED) return 5;
    if (status === OTF_STATUS.APPROVED) return 5;
    if (status === OTF_STATUS.BILLED) return 7;
    return 5;
  }

  if (userRole?.includes("ACCOUNTS")) {
    if (status === OTF_STATUS.APPROVED) return 6;
    return 6;
  }
  if (userRole?.includes("CEO")) {
    return 4;
  }
  return 4;
};

// steps.config.js

export const ALL_STEPS = [
  { key: "customer", title: "Customer" },
  { key: "coApplicant", title: "Co-Applicant" },
  { key: "property", title: "Property Details" },
  { key: "costing", title: "Costing" },
  { key: "payment", title: "Payment" },
  { key: "review", title: "Review" },
  { key: "builder-payment", title: "Builder Payment" },
  { key: "collection", title: "Billing & Collection" },
];

export const STEP_CONFIG = {
  BM: ["customer", "coApplicant", "property", "costing", "payment"],
  CRM: ["customer", "coApplicant", "property", "costing", "payment", "review"],
  ACCOUNTS: [
    "customer",
    "coApplicant",
    "property",
    "costing",
    "payment",
    "review",
    "builder-payment",
    "collection",
  ],
  CEO: [
    "customer",
    "coApplicant",
    "property",
    "costing",
    "payment",
    "review",
    "builder-payment",
    "collection",
  ],
};

export const STEP_CONFIG2 = {
  CREATE_OTF: ["customer", "coApplicant", "property", "costing", "payment"],
  REVIEW_OTF: ["customer", "coApplicant", "property", "costing", "payment", "review"],
  PAYMENT_OTF: [
    "customer",
    "coApplicant",
    "property",
    "costing",
    "payment",
    "review",
    "builder-payment",
  ],
  ACCOUNTS_OTF: [
    "customer",
    "coApplicant",
    "property",
    "costing",
    "payment",
    "review",
    "builder-payment",
    "collection",
  ],
};
export const getStepsByRole = (userRole) => {
  const allowedKeys = STEP_CONFIG[userRole] || [];
  return ALL_STEPS.filter((step) => allowedKeys.includes(step.key));
};

export const getStepsByRole2 = (permission) => {
  const allowedKeys = STEP_CONFIG2[permission] || [];
  return ALL_STEPS.filter((step) => allowedKeys.includes(step.key));
};

export const approveAllowed = (status) => {
  return ["Submitted"].includes(status);
};

const ROLE_MAX_STEP = {
  BM: "payment", // BM can see up to 'payment'
  CRM: "review", // CRM can see up to 'review'
  ACCOUNTS: "collection", // ACCOUNTS can see all steps
  CEO: "collection", // CEO can see all steps
};

export const STATUS_STEP_MAP = {
  Draft: ["customer", "coApplicant", "property", "costing", "payment"],
  Submitted: ["customer", "coApplicant", "property", "costing", "payment", "review"],
  APPROVED: [
    "customer",
    "coApplicant",
    "property",
    "costing",
    "payment",
    "review",
    "builder-payment",
  ],
  Confirmed: [
    "customer",
    "coApplicant",
    "property",
    "costing",
    "payment",
    "review",
    "builder-payment",
  ],
  BUILDER_DONE: [
    "customer",
    "coApplicant",
    "property",
    "costing",
    "payment",
    "review",
    "builder-payment",
    "collection",
  ],
  Rejected: ["customer", "coApplicant", "property", "costing", "payment"],
  Approved: ["customer", "coApplicant", "property", "costing", "payment", "review"],
  "Ready To Bill": [
    "customer",
    "coApplicant",
    "property",
    "costing",
    "payment",
    "review",
    "builder-payment",
    "collection",
  ],
  Billed: [
    "customer",
    "coApplicant",
    "property",
    "costing",
    "payment",
    "review",
    "builder-payment",
    "collection",
  ],
  Collected: [
    "customer",
    "coApplicant",
    "property",
    "costing",
    "payment",
    "review",
    "builder-payment",
    "collection",
  ],
};

export const getStepsByRoleAndStatus = (userRole, status) => {
  const roleSteps = STEP_CONFIG[userRole] || [];
  const statusSteps = STATUS_STEP_MAP[status] || [];
  const maxStep = ROLE_MAX_STEP[userRole];
  const allowedSteps = ALL_STEPS.filter(
    (step) =>
      roleSteps.includes(step.key) && // allowed by role
      statusSteps.includes(step.key) && // allowed by status
      ALL_STEPS.findIndex((s) => s.key === step.key) <=
        ALL_STEPS.findIndex((s) => s.key === maxStep) // role limit
  );

  return allowedSteps;
};

export const getStepsByPermissions = (permissions = [], status) => {
  if (!permissions?.length) return [];

  // Merge all allowed steps from permissions
  const permissionSteps = permissions.flatMap((p) => STEP_CONFIG2[p] || []);

  // Remove duplicates
  const uniqueSteps = [...new Set(permissionSteps)];

  // Apply status restriction (optional)
  const statusSteps = STATUS_STEP_MAP[status] || [];

  return ALL_STEPS.filter(
    (step) => uniqueSteps.includes(step.key) && statusSteps.includes(step.key)
  );
};
